import { create } from "zustand";

import STRINGS from "../../utils/strings";

const initialState = {
  data: [],
  loading: false,
  currentPage: STRINGS.DEFAULT_PAGE,
  resLimit: 100,
  resultCount: 0,
  currentSearch: "",
  offset: 0,
  selectedServices: 0,
};

export const useProvidedServicesStore = create((set) => ({
  ...initialState,

  setData: (data) => set({ data }),
  setLoading: (value) => set({ loading: value }),
  setCurrentPage: (page) => set({ currentPage: page }),
  setResLimit: (limit) => set({ resLimit: limit }),
  setResultCount: (count) => set({ resultCount: count }),
  setCurrentSearch: (value) => set({ currentSearch: value }),
  setOffset: (value) => set({ offset: value }),
  setSelectedServices: (count) => set({ selectedServices: count }),

  resetCurrentPage: () => set({ currentPage: 1 }),
  reset: () => set(initialState),
}));
